const defaultState = {
  isDownloadAppDialogVisible: false,
  isDownloadAppDialogDismissed: false,

  isVerificationPending: true,
  isVerificationCodeVerified: false,

  collectionFormModal: {
    isNewCollectionFormModalOpen: false,
    isEditCollectionFormModalOpen: false,
    source: null,
  },

  addToCollectionModal: {
    isVisible: false,
    isAddingPostToCollection: false,
    postId: null,
    collections: {
      data: [],
      hasMore: true,
      pagingToken: null,
    },
  },
};

const UI = (state = defaultState, action) => {
  switch (action.type) {
    case "SHOW_DOWNLOAD_APP_DIALOG":
      return {
        ...state,
        isDownloadAppDialogVisible: true,
      };

    case "HIDE_DOWNLOAD_APP_DIALOG":
      return {
        ...state,
        isDownloadAppDialogVisible: false,
        isDownloadAppDialogDismissed: true,
      };

    case "SET_IS_VERIFICATION_CODE_VERIFIED":
      return {
        ...state,
        isVerificationPending: false,
        isVerificationCodeVerified: action.isVerifed,
      };

    case "OPEN_ADD_TO_COLLECTION_MODAL":
      return {
        ...state,
        addToCollectionModal: {
          ...state.addToCollectionModal,
          isVisible: true,
          postId: action.postId,
        },
      };

    case "CLOSE_ADD_TO_COLLECTION_MODAL":
      return {
        ...state,
        addToCollectionModal: {
          ...defaultState.addToCollectionModal,
          postId: state.addToCollectionModal.postId,
        },
      };

    case "LOAD_MORE_ADD_TO_COLLECTION_MODAL_COLLECTIONS_SUCCESS":
      return {
        ...state,
        addToCollectionModal: {
          ...state.addToCollectionModal,
          collections: {
            data: [...state.addToCollectionModal.collections.data, ...action.collections],
            hasMore: action.collections.length === action.limit,
            pagingToken: action.pagingToken,
          },
        },
      };

    case "ADD_POST_TO_COLLECTION_REQUEST":
      return {
        ...state,
        addToCollectionModal: {
          ...state.addToCollectionModal,
          isAddingPostToCollection: true,
        },
      };

    case "ADD_POST_TO_COLLECTION_FAILED":
      return {
        ...state,
        addToCollectionModal: {
          ...state.addToCollectionModal,
          isAddingPostToCollection: false,
        },
      };

    case "OPEN_NEW_COLLECTION_FORM_MODAL":
      return {
        ...state,
        collectionFormModal: {
          ...state.collectionFormModal,
          isNewCollectionFormModalOpen: true,
          source: action.source,
        },
      };

    case "OPEN_EDIT_COLLECTION_FORM_MODAL":
      return {
        ...state,
        collectionFormModal: {
          ...state.collectionFormModal,
          isEditCollectionFormModalOpen: true,
        },
      };

    case "CLOSE_COLLECTION_FORM_MODAL":
      return {
        ...state,
        collectionFormModal: {
          ...state.collectionFormModal,
          isNewCollectionFormModalOpen: false,
          isEditCollectionFormModalOpen: false,
          source: null,
        },
      };

    default:
      return state;
  }
};

export default UI;



// WEBPACK FOOTER //
// ./src/reducers/UI/index.js